/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from "@/hooks/use-toast";
import { getUserInfo } from "@/lib/token";
import { apiServices } from "@/services/api.services";
import { erp } from "@/services/global.services";
import { useMemo, useState } from "react";

export const useErpMapping = () => {
  const [list, setList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id /*  */,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  function getErpKeys(obj: any, prefix: any = "") {
    let result: Array<Record<string, string>> = [];
    for (const key in obj) {
      const fullKey = prefix ? `${prefix}.${key}` : key;
      result.push({ label: fullKey, value: fullKey });

      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !Array.isArray(obj[key])
      ) {
        result = result.concat(getErpKeys(obj[key], fullKey));
      }
    }
    return result;
  }

  const onErpSearch = async ({ text, order_type }: any) => {
    console.log(text);
    setLoading(true);
    const payload = {
      data: {
        order_type: order_type,
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      erp.get,
      "post",
      payload
    );

    if (data) {
      const get_all_key = getErpKeys(data.result.metadata[erp.key]);
      setList(get_all_key);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setLoading(false);
  };
  return { onErpSearch, list, loading };
};
